import { render } from "./SocialIcons.vue?vue&type=template&id=a7c46e60&scoped=true"
import script from "./SocialIcons.vue?vue&type=script&lang=js"
export * from "./SocialIcons.vue?vue&type=script&lang=js"

import "./SocialIcons.vue?vue&type=style&index=0&id=a7c46e60&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a7c46e60"

export default script